import { BottomDrawer } from '@zenterprise-inc/ui';

import common from '@/components/survey/common/ui/styles/common.module.scss';

interface Props {
  isVisible: boolean;
  onClose: () => void;
  title: string;
  items: string[];
  onClickItem: (value: string) => void | Promise<void>;
}

export const SelectDrawer = ({ onClose, isVisible, items, onClickItem, title }: Props) => {
  return (
    <BottomDrawer.Basic isVisible={isVisible} onCloseDrawer={onClose}>
      <BottomDrawer.Basic.Header isCloseButton onCloseDrawer={onClose}>
        {title}
      </BottomDrawer.Basic.Header>
      <BottomDrawer.Basic.Contents>
        <ul>
          {items.map((value) => (
            <li
              key={value}
              className={common.drawer_list}
              onClick={() => {
                onClickItem(value);
                onClose();
              }}
            >
              <p className={common.drawer_list_item}>{value}</p>
            </li>
          ))}
        </ul>
      </BottomDrawer.Basic.Contents>
    </BottomDrawer.Basic>
  );
};
